import { Overlay } from '@angular/cdk/overlay';
import { ComponentPortal } from '@angular/cdk/portal';
import { Component, EventEmitter, Input, OnDestroy, OnInit, Output, ViewChild } from '@angular/core';
import { CommonModule } from '@angular/common';
import { Router, RouterModule } from '@angular/router';
import { avantorAnimations } from '@core/animations/animations';
import { SITE_LINK } from '@core/constants';
import { ChatService } from '@core/services/chat/chat-api';
import { HeaderBarService } from '@core/services/header-bar/header-bar-api';
import { MessageService } from '@core/services/message/message-api';
import { NewsService } from '@core/services/news/news-api';
import { NotificationsService } from '@core/services/notifications/notifications-api';
import { OrgAndStockroomService } from '@core/services/org-and-stockroom/org-and-stockroom-api';
import { PrivilegeService } from '@core/services/privilege/privilege-api';
import { TokenHolderService } from '@core/services/token-holder/token-holder-api';
import { environment } from '../../../../../environments/environment';
import { UserService } from '@core/services/user/user-api';
import { loadPrivileges } from '@core/store/actions/common.actions';
import { AppState } from '@core/store/reducers/common.reducer';
import { getPrivileges, getUserConfig } from '@core/store/selectors/common.selectors';
import { Store } from '@ngrx/store';
import { AvantorDialogsService } from '@shared/dialogs/avantor-dialogs-api';
import { Notification } from '@shared/models/notification.model';
import { User } from '@shared/models/user.model';
import { Subscription } from 'rxjs';
import { ResponsiveEnterprisePopupComponent } from '../responsive-enterprise-popup/responsive-enterprise-popup';
import { AnalyticsService } from '@core/services/analytics/analytics-api';
import { SoftwareService } from '@core/services/download-center/software/software-api';
import { AppService } from '@core/services/app/app-api';
import { SharedModule } from '@shared/shared.module';
import { FormsModule } from '@angular/forms';
import { MaterialsModule } from '@shared/materials.module';
import { BASE64_IMAGE, BASE_IMAGE1 } from '../../../../../../public/js/sinch_chat_image';

type OrgStockroom = {
  organization: string;
  stockroom: string;
}
@Component({
  selector: 'app-responsive-menu',
  templateUrl: './responsive-menu.html',
  styleUrls: ['./responsive-menu.scss'],
  animations: [avantorAnimations],
  standalone: true,
  imports: [CommonModule, SharedModule, FormsModule, MaterialsModule, RouterModule],
})
export class ResponsiveMenuComponent implements OnInit, OnDestroy {
  @Input() userData!: User
  @Output() toggleData = new EventEmitter();
  @Output() toggleUserData = new EventEmitter();
  private manualUpdated: boolean = false;



  readonly SITE_LINK = SITE_LINK;

  storeSub!: Subscription;
  userType: any = "";
  approvalCount = 0;
  messageCount = 0;
  newsCount = 0;
  notifCount = 0;
  notifications: Notification[] = [];
  notifInterval: number = 1000 * 60 * 5;
  widgetData: any = [];
  palmRunInterpretation: string = '';
  businessDetails: any;
  isChatDisabled = false;

  userPrivileges = {
    activities: {
      consumeStock: false,
      replenishStock: false,
      receiveStock: false,
      createBarcodes: false,
      approval: false,
      stockCorrection: false,
      scannerFile: false,
      returnStock: false,
      transferStock: false,
    },
    overview: {
      requests: false,
      orders: false,
      reporting: false,
      articleLog: false,
      stockroomLog: false,
      trackOrder: false,
      products: false
    },
    administration: {
      vendorMaintenance: false,
      reference: false,
      reasonCode: false,
      productMaintenance: false,
      userMaintenance: false,
      deptMaintenance: false,
      locationMaintenance: false,
      costCenter: false,
      copyMoveArticle: false,
      exportImportProduct: false,
      messageCenter: false,
      manageStockroom: false,
      integrationMaintenance: false,
      localizationMaint: false,
      archivePurge: false,
      exportImportStockroom: false,
      userRoleMaintenance: false,
    },
    downloadCenter: false
  };

  isCountryAdminViewOnly: boolean = false;
  isShowAdminConsole: boolean = false;
  isAdminConsole: any;
  isSupportTicketReportEnabled: boolean = environment.isSupportTicketReportEnabled;
  userManualId: any;
  envDetails = environment;
  constructor(
    private router: Router,
    private privelegeService: PrivilegeService,
    private messageService: MessageService,
    private newsService: NewsService,
    private notificationService: NotificationsService,
    private userService: UserService,
    public orgAndStockroomService: OrgAndStockroomService,
    private avantorDialogs: AvantorDialogsService,
    private overlay: Overlay,
    private tokenHolderService: TokenHolderService,
    private headerService: HeaderBarService,
    private chatSupportService: ChatService,
    private store: Store<AppState>,
    private analyticsService: AnalyticsService,
    private softwareService: SoftwareService,
    public appService: AppService,
  ) {
    this.isAdminConsole = sessionStorage.getItem('isAdminConsole') || 'No';
    this.intializeData();
    this.initOrgStockroom();

    if (this.isAdminConsole == 'No') {
      this.getNotifications();
    }
    this.openPanel = true;
  }

  ngOnInit(): void {
    this.storeSub = this.store.select(getPrivileges).subscribe((privileges: any) => {
      this.initUserPriveleges(privileges);
    })
    this.messageService.getMessageCounts().subscribe(result => {
      this.messageCount = result;
    });
    this.newsService.getNewsCounts().subscribe(result => {
      this.newsCount = result;
    });
    this.notificationService.getNotificationCounts().subscribe(result => {
      this.notifCount = result;
    });
    this.userType = this.userData.userType;

    this.initJumpWidget();
    this.isCountryAdminViewOnly = this.userData.isViewCountryAdmin;
    if (this.userType === 'SUPER_USER') {
      this.isShowAdminConsole = true;
    } else if (this.userType === 'COUNTRY_ADMIN') {
      this.isShowAdminConsole = true;
    }
    this.isAdminConsole = sessionStorage.getItem('isAdminConsole') || 'No';
    this.isSupportTicketReportEnabled = environment.isSupportTicketReportEnabled;
  }



  initJumpWidget() {
    this.headerService.jumpWidget$.subscribe(res => {
      this.widgetData = res;
    });
  }



  /**---------------------------------------------
 * @PAGE_NAVIGATE
 * Navigate to pages
 */
  navigateToPage(pageUrl: string) {
    this.router.navigate(['/app/' + pageUrl]);
    this.close();
  }

  navigateToAbsolutePage(pageUrl: string) {
    this.router.navigateByUrl(pageUrl);
    this.close();
  }

  /**--------------------------------------
   * @DIALOG_CHANGE_STOCKROOM
   * Header dialog for changing of stockroom
   */
  dialogChangeOrganizationStockroom() {
    this.avantorDialogs.openDialogChangeOrganizationOrStockroom();
  }


  /**---------------------------------------------
 * @USER_PRIVELAGE_CHECK
 * Check user's privilege
 */
  initUserPriveleges(privileges: any) {
    this.userPrivileges.activities.consumeStock = this.privelegeService.findPrivelege('priv_consume_stock_icon', privileges) ? true : false;
    this.userPrivileges.activities.replenishStock = this.privelegeService.findPrivelege('priv_replenish_stock_icon', privileges) ? true : false;
    this.userPrivileges.activities.receiveStock = this.privelegeService.findPrivelege('priv_receive_stock_icon', privileges) ? true : false;
    this.userPrivileges.activities.createBarcodes = this.privelegeService.findPrivelege('priv_create_barcode_icon', privileges) ? true : false;
    this.userPrivileges.activities.approval = this.privelegeService.findPrivelege('priv_approval_icon', privileges) ? true : false;
    this.userPrivileges.activities.stockCorrection = this.privelegeService.findPrivelege('priv_administer_stock_icon', privileges) ? true : false;
    this.userPrivileges.activities.scannerFile = this.privelegeService.findPrivelege('priv_palm_run_report_icon', privileges) ? true : false;
    this.userPrivileges.activities.returnStock = this.privelegeService.findPrivelege('priv_return_stock_icon', privileges) ? true : false;
    this.userPrivileges.activities.transferStock = this.privelegeService.findPrivelege('priv_setup_copyandmove_articles_icon', privileges) && this.privelegeService.findChildPrivelege('priv_move_articles', privileges) ? true : false;

    this.userPrivileges.overview.requests = this.privelegeService.findPrivelege('priv_overview_icon', privileges) ? true : false;
    this.userPrivileges.overview.orders = this.privelegeService.findPrivelege('priv_overview_icon', privileges) ? true : false;
    this.userPrivileges.overview.reporting = this.privelegeService.findPrivelege('priv_overview_report_icon', privileges) ? true : false;
    this.userPrivileges.overview.articleLog = this.privelegeService.findPrivelege('priv_overview_activitylog_icon', privileges) ? true : false;
    this.userPrivileges.overview.stockroomLog = this.privelegeService.findPrivelege('priv_overview_activitylog_icon', privileges) ? true : false;
    this.userPrivileges.overview.trackOrder = this.privelegeService.findPrivelege('priv_order_tracking_icon', privileges) ? true : false;
    this.userPrivileges.overview.products = this.privelegeService.findPrivelege('priv_overview_icon', privileges) ? true : false;


    this.userPrivileges.administration.vendorMaintenance = this.privelegeService.findPrivelege('priv_setup_vendor_maintenance_icon', privileges) ? true : false;
    this.userPrivileges.administration.reference = this.privelegeService.findPrivelege('priv_setup_reference_code_maintenance_icon', privileges) ? true : false;
    this.userPrivileges.administration.reasonCode = this.privelegeService.findPrivelege('priv_setup_reason_code_maintenance_icon', privileges) ? true : false;
    this.userPrivileges.administration.productMaintenance = this.privelegeService.findPrivelege('priv_setup_product_maintenance_icon', privileges) ? true : false;
    this.userPrivileges.administration.userMaintenance = this.privelegeService.findPrivelege('priv_setup_user_maintenance_icon', privileges) ? true : false;
    this.userPrivileges.administration.deptMaintenance = this.privelegeService.findPrivelege('priv_setup_department_maintenance_icon', privileges) ? true : false;
    this.userPrivileges.administration.locationMaintenance = this.privelegeService.findPrivelege('priv_setup_location_maintenance_icon', privileges) ? true : false;
    this.userPrivileges.administration.costCenter = this.privelegeService.findPrivelege('priv_setup_cost_center_maintenance_icon', privileges) ? true : false;
    this.userPrivileges.administration.copyMoveArticle = this.privelegeService.findPrivelege('priv_setup_copyandmove_articles_icon', privileges) ? true : false;
    this.userPrivileges.administration.exportImportProduct = this.privelegeService.findPrivelege('priv_setup_import_export_stockroom_icon', privileges) ? true : false;
    this.userPrivileges.administration.messageCenter = this.privelegeService.findPrivelege('priv_setup_message_center_icon', privileges) ? true : false;
    this.userPrivileges.administration.manageStockroom = this.privelegeService.findPrivelege('priv_setup_manage_stockroom_icon', privileges) ? true : false;
    this.userPrivileges.administration.integrationMaintenance = this.privelegeService.findPrivelege('priv_setup_integrations_icon', privileges) ? true : false;
    this.userPrivileges.administration.localizationMaint = this.privelegeService.findPrivelege('priv_setup_localization_maintenance_icon', privileges) ? true : false;
    this.userPrivileges.administration.archivePurge = this.privelegeService.findPrivelege('priv_setup_archive_purge', privileges) ? true : false;
    this.userPrivileges.administration.exportImportStockroom = this.privelegeService.findPrivelege('priv_setup_import_export_stock_icon', privileges) ? true : false;
    this.userPrivileges.administration.userRoleMaintenance = this.privelegeService.findPrivelege('priv_setup_role_maintenance_icon', privileges) ? true : false;
    this.userPrivileges.downloadCenter = this.privelegeService.findPrivelege('priv_download_softwares_icon', privileges) ? true : this.privelegeService.findPrivelege('priv_download_documents_icon', privileges) ? true : false;

    if (this.isAdminConsole == 'No' && this.userPrivileges.activities.approval && !this.approvalCounter) {
      this.requestApprovalCount();
      this.getApprovalCount();
    }
  }

  /**--------------------------------------
   * @CURRENT_ORG_STOCKROOM
   */
  public currentOrgStockroom!: OrgStockroom;
  public replenishModel?: string;

  initOrgStockroom() {
    const currentOrgStockroom = this.orgAndStockroomService.getStockroomAndOrgName();
    if (currentOrgStockroom) {
      const data = JSON.parse(currentOrgStockroom);
      this.currentOrgStockroom = data;
      this.replenishModel = data.organization.replenishModel;
      this.palmRunInterpretation = data.organization.palmRunInterpretation
    }
  }

  counter: any;
  intializeData() {
    this.counter = setInterval(async () => {
      if (this.router.url.toLowerCase().includes('app') && this.isAdminConsole == 'No') {
        this.initPollingRequest();
      }
    }, this.notifInterval)
  }

  getUserManaulaId() {
    this.softwareService.getUserManual('IM Enterprise Manual').subscribe({
      next: (res: any) => {
        this.userManualId = res?.data;
        this.appService.getResponsiveUpdatedUserManualId(this.userManualId);
      },
      error: (error: any) => {
        if (error?.status === 401) {
          this.userManualId = null;
        }
      }
    })
  }

  async initPollingRequest() {
    await this.messageService.getMessageCount();
    await this.newsService.getNewsCount();
    await this.notificationService.getNotificationsCount();
  }

  async getNotifications() {
    this.notifications = [];
    await this.userService.getNotifications().then(notifs => {
      let notifications = notifs.data;
      notifications.forEach((element: any) => {
        if (element.markedAsRead == false) {
          this.notifications.push(element);
        }
      });
    }).catch(error => {
      if (error?.status !== 401) {
        console.log(error);
      }
    });
  }

  initializeChat(): void {
    if (this.isAdminConsole == 'Yes') {
      return;
    }

    if (this.businessDetails || this.isChatDisabled) {
      return;
    }

    this.fetchgetBusinessStatus();
  }

  fetchgetBusinessStatus() {
    this.chatSupportService.getBusinessStatus().subscribe((data: any) => {
      this.businessDetails = data;
      if (this.businessDetails?.isShinChatEnable === 'YES') {
        const find = this.businessDetails?.queue?.find((item: any) => item.id === this.businessDetails.sinchBusinessId);
        if (find?.status === 'ONLINE') {
          this.initChatLayer();
        } else {
          this.isChatDisabled = true;
        }
      } else {
        this.isChatDisabled = true;
      }
    }, error => {
      console.error('Error fetching data:', error);
    });
  }

  initChatLayer(): void {
    if (document.querySelector('script[src="/js/sinch.js"]')) {
      this.loadSinchChatFormDetails();
      return;
    }

    const sdkScript = document.createElement('script');
    sdkScript.type = 'text/javascript';
    sdkScript.src = '/js/sinch.js';
    sdkScript.async = false;
    sdkScript.onload = () => {
      this.loadSinchChatFormDetails();
    };
    document.body.appendChild(sdkScript);
  }

  private loadSinchChatFormDetails(): void {
    const customActions = [{
      id: 'END_CHAT',
      image: BASE_IMAGE1
    }];
    const customTitle = 'Digital Tech Support';
    const storageValue = sessionStorage.getItem('config');
    let parsedValue: any;
    let orgName: string | undefined;

    if (storageValue !== null) {
      parsedValue = JSON.parse(storageValue);
    }

    const sessionStorageData = sessionStorage.getItem('cStockroomAndOrg');
    if (sessionStorageData !== null) {
      orgName = JSON.parse(sessionStorageData).organization.orgName;
    }

    const prechatForm = {
      elements: [
        {
          type: 'image',
          url: BASE64_IMAGE,
          alignment: 'center',
          width: 150,
          height: 50
        },
        {
          type: 'text',
          text: 'By clicking “Start Chat” you agree that this conversation may be transcribed, used, stored, or accessed by our third-party service providers in accordance with our [Privacy Policy](https://www.avantorsciences.com/us/en/privacy-policy)',
          alignment: 'center',
        },
        {
          type: 'spacer',
          size: 'xs',
        },
        {
          id: 'firstName',
          type: 'input',
          label: 'First Name:',
          required: true,
          placeholder: 'Enter First Name',
          defaultValue: parsedValue?.firstName ? parsedValue.firstName : ''
        },
        {
          id: 'lastName',
          type: 'input',
          label: 'Last Name:',
          required: true,
          placeholder: 'Enter Last Name',
          defaultValue: parsedValue?.lastName ? parsedValue.lastName : ''
        },
        {
          id: 'email',
          type: 'input',
          label: 'Email:',
          required: true,
          placeholder: 'Enter Email',
          defaultValue: parsedValue?.email ? parsedValue.email : ''
        },
        {
          id: 'businessPhone',
          type: 'input',
          label: 'Business Phone:',
          required: true,
          placeholder: 'Enter Business Phone',
          defaultValue: parsedValue?.phoneNumber ? parsedValue.phoneNumber : ''
        },
        {
          id: 'organizationName',
          type: 'input',
          label: 'Organization Name:',
          required: false,
          placeholder: 'Enter Organization Name',
          defaultValue: orgName ? orgName : ''
        },
        {
          type: 'spacer',
          size: 'md',
        },
      ]
    };

    const localStorageKey = '__session_id__.' + this.businessDetails.sinchChannelId;
    (window as any).Chatlayer.init({
      channelId: this.businessDetails.sinchChannelId,
      region: this.businessDetails.sinchRegion,
      title: `${customTitle}`,
      prechatForm: prechatForm,
      customActions: customActions,
    });

    (window as any).Chatlayer.on('init', async () => {
      (window as any).Chatlayer.setSessionData('queueId', this.businessDetails.sinchBusinessId);
      (window as any).Chatlayer.setSessionData('PageURL', environment.redirectUri + '/app');
    });

    (window as any).Chatlayer.on('widget:custom_action', async (id: any) => {
      if (id.id === 'END_CHAT') {
        localStorage.removeItem(localStorageKey);
        (window as any).Chatlayer.sendMessage('User ended chat');
      }
    });

    (window as any).Chatlayer.on('widget:closed', () => {
      (window as any).Chatlayer.sendMessage('User ended chat');
    });
  }

  /**--------------------------------------
   * @SIDEBAR_PANELS
   * Overlay panel toggle for:
   * News Panel,
   * Messages Panel
   */

  toggleNewsPanel(status: boolean) {
    this.toggleData.emit("news");
    this.close();
  }

  onStartChat() {
    this.analyticsService.sendDetailsForClickEventTracking({
      ModuleName: 'Header',
      EventUniqueID: 'header_chat_support_click',
      click_value: 'Chat Support',
      download_format: ''
    });

    const chatLayer = (window as any).Chatlayer;
    if (chatLayer?.open) {
      chatLayer.open();
    }
  }

  /**---------------------------------------------
 * @CLOSE_PANEL
 * Close panel event
 */
  @Input() openPanel: boolean = false;
  @Output() closePanel = new EventEmitter<void>();

  close() {
    this.closePanel.emit();
  }

  /**--------------------------------------
   * @LOGOUT
   * User menu logout
   */
  logout() {
    this.userTrackingLogout();
  }

  palmRunOnHand(model: string) {
    if (model == 'ON_HAND_MODEL') {
      this.analyticsEvent('Scanner Replenish On Hand ', '/app/activities/scanner-replenish/on-hand')
      this.router.navigate(['/app/activities/scanner-replenish/on-hand']);
      this.close();
    } else if (model == 'PUTAWAY_MODEL') {
      this.analyticsEvent('Scanner Replenish Putaway ', '/app/activities/scanner-replenish/put-away')
      this.router.navigate(['/app/activities/scanner-replenish/put-away']);
      this.close();
    }
    else {
      this.palmRunOnHand(this.palmRunInterpretation === 'PUT_AWAY' ? 'PUTAWAY_MODEL' : 'ON_HAND_MODEL')
    }
  }

  approvalCounter: any;
  getApprovalCount() {
    this.approvalCounter = setInterval(() => {
      if (this.router.url.toLowerCase().includes('app') && this.isAdminConsole == 'No') {
        this.requestApprovalCount();
      }
    }, this.notifInterval);
  }
  async requestApprovalCount() {
    this.headerService.getApprovalCount().subscribe({
      next: (response: any) => {
        this.approvalCount = response;
      },
      error: (error: any) => {
        if (error?.status === 401) {
          this.approvalCount = 0;
        }
      }
    });
  }

  overlayInstance!: any
  onEnterpriseClick(connectedTo: any) {
    const positionStrategy = this.overlay.position()
      .flexibleConnectedTo(connectedTo)
      .withPositions([{
        originX: 'end',
        originY: 'center',
        overlayX: 'start',
        overlayY: 'center',
      }, {
        originX: 'start',
        originY: 'center',
        overlayX: 'end',
        overlayY: 'center',
      }]);

    const overlayRef = this.overlay.create({
      hasBackdrop: true,
      backdropClass: 'cdk-overlay-transparent-backdrop',
      positionStrategy,
    });

    // Create ComponentPortal that can be attached to a PortalHost
    const filePreviewPortal = new ComponentPortal(ResponsiveEnterprisePopupComponent, null);

    // Attach ComponentPortal to PortalHost
    this.overlayInstance = overlayRef.attach(filePreviewPortal);

    this.overlayInstance.instance.closePanel.subscribe(() => {
      overlayRef.dispose();
      overlayRef.detach();
    });

    overlayRef.backdropClick().subscribe(() => {
      overlayRef.dispose();
      overlayRef.detach();
    })


  }
  toggleUserPanel(value: boolean) {
    this.toggleData.emit("user");
    this.orgAndStockroomService.isShowPdfViewer = true;
    if (!this.manualUpdated) {
      this.orgAndStockroomService.updatemanual(true);
      this.manualUpdated = true;
    }
    this.getUserManaulaId();
    this.close();
  }
  ngOnDestroy() {
    clearInterval(this.approvalCounter)
    this.storeSub.unsubscribe();
  }
  scrollToTop() {
    window.scrollTo(0, 0);
  }

  naivgateToAdminConosleOrgView() {
    let currentOrgStockroom = this.orgAndStockroomService.getStockroomAndOrg();
    this.close();
    if (currentOrgStockroom) {
      const data = JSON.parse(currentOrgStockroom);
      this.router.navigate(['app/admin/organization/organization-maintenance/manage-organization/required-settings-normal'], { queryParams: { mode: 'view', id: data.orgId } });
    }

  }

  analyticsEvent(moduleName: any, route: any) {

    this.analyticsService.sendDetailsForClickEventTracking({
      event: "im_header_menu_click",
      ModuleName: moduleName,
      link_click: route,
    })
  }

  userTrackingLogout() {
    const userTrackingInfo = sessionStorage.getItem('userTrackingInfo');
    this.orgAndStockroomService.auditLogout().then((data: any) => {
      if (userTrackingInfo) {
        sessionStorage.removeItem('userTrackingInfo');
      }
      this.tokenHolderService.logoutSession();
    }).catch(err => {
      console.log(err);
      this.tokenHolderService.logoutSession();
    });
  }

}
